var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TitleSlide',{attrs:{"title":"Common Threats","background-image":require('@/assets/backgrounds/2700_CT_2022_Title.png'),"background-size":"contain","background-color":"#12335f"}})}
var staticRenderFns = []

export { render, staticRenderFns }